import { Indicator } from '../../../Common/Charts/Indicator';
import { useGeneralResultsChartsDataContext } from './hooks/useGeneralResultsChartsDataContext';

export const FetalDeaths = () => {
    const { chartData } = useGeneralResultsChartsDataContext();

    return (
        <Indicator
            title={'Indice de Obitos Fetais'}
            indicatorValue={chartData?.indicators?.fetalDeaths}
            className='aligned-container'
        />
    );
};
